import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import NfuVs from "../components/administrador/recoleccion/NfuVs";
import RecoleccionNfuProvinciaBarras from "../components/administrador/recoleccion/recoleccion_nfu_provincia_barras";
import TiempoRecoleccionProvincia from "../components/administrador/recoleccion/tiempo_recoleccion_provincia";
import RecoleccionesTotalesMensuales from "../components/administrador/recoleccion/recolecciones_totales_mensuales";
import PuntosCategoriaSubcategoria from "../components/administrador/recoleccion/puntos_generacion";
import ToneladasProvincia from "../components/administrador/recoleccion/toneladas_provincia";
import RecoleccionGestorTransporte from "../components/administrador/recoleccion/recoleccion_gestor_transporte";
import TiempoRecoleccionTransporte from "../components/administrador/recoleccion/tiempo_recoleccion_transporte";
import NfuTiposMes from "../components/administrador/recoleccion/nfu_tipos_mes";
import useProvinciasCiudades from "../hooks/administrador/recoleccion/useProvinciasCiudades";
import GestoresTipoAprovechamiento from "../components/administrador/recoleccion/GestoresTipoAprovechamiento";
import "../styles/administrador.css";

const Recoleccion = () => {
  const [year, setYear] = useState(new Date().getFullYear());
  const [mesSeleccionado, setMesSeleccionado] = useState(0);
  const [token, setToken] = useState(null);
  const [idAdministrador, setIdAdministrador] = useState(null);
  const location = useLocation();
  const { provinciasCiudades, loading } = useProvinciasCiudades(
    token,
    year,
    mesSeleccionado,
    idAdministrador
  );
  const [provincias, setProvincias] = useState([]);
  const [ciudades, setCiudades] = useState([]);
  const [provinciaSeleccionada, setProvinciaSeleccionada] = useState(null);
  const [ciudadSeleccionada, setCiudadSeleccionada] = useState(null);

  const currentYear = new Date().getFullYear();
  const years = Array.from(
    { length: currentYear - 2018 + 1 },
    (_, i) => currentYear - i
  );
  const meses = [
    "Enero",
    "Febrero",
    "Marzo",
    "Abril",
    "Mayo",
    "Junio",
    "Julio",
    "Agosto",
    "Septiembre",
    "Octubre",
    "Noviembre",
    "Diciembre",
  ];

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const tokenFromUrl = params.get("token");
    const idFromUrl = params.get("idAdministrador");

    if (tokenFromUrl) {
      setToken(tokenFromUrl);
    }
    if (idFromUrl) {
      setIdAdministrador(parseInt(idFromUrl, 10));
    }
  }, [location.search]);

  useEffect(() => {
    if (!loading && provinciasCiudades.length > 0) {
      const provinciasUnicas = [
        ...new Map(
          provinciasCiudades.map((item) => [
            item.id_provincia,
            { id: item.id_provincia, nombre: item.nombre_provincia },
          ])
        ).values(),
      ];
      setProvincias(provinciasUnicas);
    }
  }, [provinciasCiudades, loading]);

  useEffect(() => {
    if (provinciaSeleccionada) {
      const ciudadesFiltradas = provinciasCiudades.filter(
        (item) => item.id_provincia === provinciaSeleccionada
      );
      setCiudades(
        ciudadesFiltradas.map((item) => ({
          id: item.id_ciudad,
          nombre: item.nombre_ciudad,
        }))
      );
    } else {
      setCiudades([]);
    }
  }, [provinciaSeleccionada, provinciasCiudades]);

  return (
    <div className="dashboard-container">
      <div className="select-mes">
        <div className="select-row">
          <div className="select-item">
            <label>Año:</label>
            <select
              value={year}
              onChange={(e) => setYear(Number(e.target.value))}
            >
              {years.map((y) => (
                <option key={y} value={y}>
                  {y}
                </option>
              ))}
            </select>
          </div>
          <div className="select-item">
            <label>Mes:</label>
            <select
              value={mesSeleccionado}
              onChange={(e) =>
                setMesSeleccionado(
                  e.target.value === "acumulado" ? 0 : Number(e.target.value)
                )
              }
            >
              <option value="acumulado">Acumulado</option>
              {meses.map((m, index) => (
                <option key={index} value={index + 1}>
                  {m}
                </option>
              ))}
            </select>
          </div>
        </div>
        <div className="select-row">
          <div className="select-item">
            <label>Provincia:</label>
            <select
              value={provinciaSeleccionada || ""}
              onChange={(e) => {
                const value =
                  e.target.value === "" ? null : Number(e.target.value);
                setProvinciaSeleccionada(value);
                setCiudadSeleccionada(null);
              }}
            >
              <option value="">Acumulado</option>
              {provincias.map((prov) => (
                <option key={prov.id} value={prov.id}>
                  {prov.nombre}
                </option>
              ))}
            </select>
          </div>
          <div className="select-item">
            <label>Ciudad:</label>
            <select
              value={ciudadSeleccionada || ""}
              onChange={(e) => {
                const value =
                  e.target.value === "" ? null : Number(e.target.value);

                setCiudadSeleccionada(value);
              }}
              disabled={!provinciaSeleccionada}
            >
              <option value="">Acumulado</option>
              {ciudades.map((ciu) => (
                <option key={ciu.id} value={ciu.id}>
                  {ciu.nombre}
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>
      <div className="container-graficas">
          <NfuVs
            key={`nfu-vs-${year}-${mesSeleccionado}-${
              provinciaSeleccionada || "all"
            }-${ciudadSeleccionada || "all"}`}
            year={year || new Date().getFullYear()}
            mes={mesSeleccionado || 0}
            token={token}
            idAdministrador={idAdministrador}
            provinciaSeleccionada={provinciaSeleccionada}
            ciudadSeleccionada={ciudadSeleccionada}
          />

        <NfuTiposMes
          key={`nfu-tipos-mes-${year}-${mesSeleccionado}-${
            provinciaSeleccionada || "all"
          }-${ciudadSeleccionada || "all"}`}
          year={year}
          mes={mesSeleccionado}
          token={token}
          idAdministrador={idAdministrador}
          provinciaSeleccionada={provinciaSeleccionada}
          ciudadSeleccionada={ciudadSeleccionada}
        />

        <GestoresTipoAprovechamiento
          key={`gestores-aprovechamiento-${year}-${mesSeleccionado}-${
            provinciaSeleccionada || "all"
          }-${ciudadSeleccionada || "all"}`}
          year={year}
          mes={mesSeleccionado}
          token={token}
          idAdministrador={idAdministrador}
          provinciaSeleccionada={provinciaSeleccionada}
          ciudadSeleccionada={ciudadSeleccionada}
        />

        <PuntosCategoriaSubcategoria
          key={`puntos-categoria-${year}-${mesSeleccionado}-${
            provinciaSeleccionada || "all"
          }-${ciudadSeleccionada || "all"}`}
          year={year}
          mes={mesSeleccionado}
          token={token}
          idAdministrador={idAdministrador}
          provinciaSeleccionada={provinciaSeleccionada}
          ciudadSeleccionada={ciudadSeleccionada}
        />

        {/* <RecoleccionesTotalesMensuales
          key={`recolecciones-totales-${year}-${mesSeleccionado}-${
            provinciaSeleccionada || "all"
          }-${ciudadSeleccionada || "all"}`}
          year={year}
          mes={mesSeleccionado}
          token={token}
          idAdministrador={idAdministrador}
          provinciaSeleccionada={provinciaSeleccionada}
          ciudadSeleccionada={ciudadSeleccionada}
        /> */}
        <RecoleccionNfuProvinciaBarras
          key={`recoleccion-provincia-${year}-${mesSeleccionado}-${
            provinciaSeleccionada || "all"
          }-${ciudadSeleccionada || "all"}`}
          year={year}
          mes={mesSeleccionado}
          token={token}
          idAdministrador={idAdministrador}
          provinciaSeleccionada={provinciaSeleccionada}
          ciudadSeleccionada={ciudadSeleccionada}
        />
        <RecoleccionGestorTransporte
          key={`gestor-transporte-${year}-${mesSeleccionado}-${
            provinciaSeleccionada || "all"
          }-${ciudadSeleccionada || "all"}`}
          year={year}
          mes={mesSeleccionado}
          token={token}
          idAdministrador={idAdministrador}
          provinciaSeleccionada={provinciaSeleccionada}
          ciudadSeleccionada={ciudadSeleccionada}
        />

        <ToneladasProvincia
          key={`toneladas-provincia-${year}-${mesSeleccionado}-${
            provinciaSeleccionada || "all"
          }-${ciudadSeleccionada || "all"}`}
          year={year}
          mes={mesSeleccionado}
          token={token}
          idAdministrador={idAdministrador}
          provinciaSeleccionada={provinciaSeleccionada}
          ciudadSeleccionada={ciudadSeleccionada}
        />

        <TiempoRecoleccionProvincia
          key={`tiempo-prov-${year}-${mesSeleccionado}-${
            provinciaSeleccionada || "all"
          }-${ciudadSeleccionada || "all"}`}
          year={year}
          mes={mesSeleccionado}
          token={token}
          idAdministrador={idAdministrador}
          provinciaSeleccionada={provinciaSeleccionada}
          ciudadSeleccionada={ciudadSeleccionada}
        />

        <TiempoRecoleccionTransporte
          key={`tiempo-transporte-${year}-${mesSeleccionado}-${
            provinciaSeleccionada || "all"
          }-${ciudadSeleccionada || "all"}`}
          year={year}
          mes={mesSeleccionado}
          token={token}
          idAdministrador={idAdministrador}
          provinciaSeleccionada={provinciaSeleccionada}
          ciudadSeleccionada={ciudadSeleccionada}
        />
        
      </div>
    </div>
  );
};

export default Recoleccion;
